import { Box, Button, Typography } from "@mui/material";
import { colors } from "../../styles/color";
import { EditProfileIcon } from "../../assets/icons";
import TextInput from "../TextInput";
import ErrorTextBox from "./ErrorTextBox";
import CkEditoComponent from "./CkEditorComponent";

const ProfileEdit = (props: any) => {
  const {
    column1,
    column2,
    column3,
    column4,
    file,
    handleFormChange,
    formErrors,
    buttonName,
    handleFormSubmit,
    handleChange,
    placeholder1,
    placeholder2,
    placeholder3,
    placeholder4,
    value1,
    value2,
    value3,
    value4,
    value5,
    name1,
    name2,
    name3,
    name4,
    name5,
    isTextInput,
    readOnly,
    buttonSvg,
    buttonStyles,
    cancelButtonClick,
    isViewCancelButton,
    setCkEditor,
  } = props;

  console.log(
    value4,
     "value1");
  return (
    <Box
      sx={{
        width: { sm: "100%", xs: "auto" },
        maxWidth: "438px",
        m: "auto",
        textAlign: "center",
        p: "10px",
      }}
    >
      <Box>
        <img
          src={file ? URL?.createObjectURL(file) : value1}
          alt="profile"
          width="85px"
          height="85px"
          style={{
            borderRadius: "50%",
            minHeight: "85px",
            minWidth: "85px",
            border: `2px solid ${colors.basics.primary}`,
            padding: "5px",
            objectFit: "cover",
            objectPosition: "center",
          }}
        />
        <Box>
          <input
            accept="image/jpeg, image/png, image/jpg"
            height="85px"
            type="file"
            width="85px"
            style={{ display: "none" }}
            name={name1}
            id="multiFiles"
            onChange={handleChange}
          />
        </Box>
      </Box>
      {!readOnly.col1 && (
        <Box
          mt={"-40px"}
          ml={"70px"}
          sx={{
            "& svg": {
              width: "40px",
              height: "40px",
            },
          }}
        >
          <label htmlFor="multiFiles" style={{ cursor: "pointer" }}>
            <EditProfileIcon />{" "}
          </label>
        </Box>
      )}

      <Box mt={"28px"}>
        <TextInput
          placeholder={placeholder1}
          title={column1}
          onChange={handleFormChange}
          value={value2}
          name={name2}
          inputProps={{ readOnly: readOnly.col2 }}
        />
        <ErrorTextBox>{formErrors[column1]}</ErrorTextBox>
      </Box>
      <Box
        mt={"10px"}
        sx={{
          "& .MuiOutlinedInput-input": {
            color: colors.gray[500],
          },
        }}
      >
        <TextInput
          placeholder={placeholder2}
          title={column2}
          value={value3}
          inputProps={{ readOnly: readOnly.col3 }}
          name={name3}
        />
        <ErrorTextBox>{formErrors[column2]}</ErrorTextBox>
      </Box>
      <Box mt={"10px"}>
        <TextInput
          inputProps={{ readOnly: readOnly.col4 }}
          placeholder={placeholder3}
          title={column3}
          onChange={readOnly.col4 ? undefined : handleFormChange}
          value={value4}
          name={name4}
          type="text "
          // disabled={readOnly.col4}
        />
        <ErrorTextBox>{formErrors[column3]}</ErrorTextBox>
      </Box>
      <Box
        sx={
          isTextInput
            ? {
                "& .ck-editor ": {
                  backgroundColor: colors.dark[600],
                  padding: "20px",
                  borderRadius: "10px",
                  color: "white",
                },
                ".ck.ck-editor__main>.ck-editor__editable": {
                  backgroundColor: "transparent",
                  border: 0,
                },
                "& .ck-editor__top ": {
                  display: "none",
                },

                "& .ck-content p ": {
                  background: "none",
                  border: "none",
                  marginTop: "0 !important",
                  marginBottom: "15px !important",
                },
                "& .ck-content p a": {
                  color: "#A175FF !important",
                  textDecoration: "none",
                },
                "& .ck-content p:last-child ": {
                  marginBottom: "0 !important",
                },
              }
            : {}
        }
        mt={"10px"}
      >
        {isTextInput ? (
          <>
            <Typography
              sx={{ color: colors.gray[300] }}
              variant="body2"
              lineHeight="140%"
              mb="6px"
              textAlign="left"
              textTransform="capitalize"
            >
              {column4}
            </Typography>

            <CkEditoComponent
              data={value5}
              setData={setCkEditor}
              name={name5}
              placeholder={placeholder4}
              height="120px"
            />
          </>
        ) : (
          <TextInput
            inputProps={{ readOnly: readOnly.col5 }}
            placeholder={placeholder4}
            title={column4}
            onChange={(e: any) => setCkEditor(e.target.value)}
            value={value5}
            name={name5}
          />
        )}
        <ErrorTextBox>{formErrors[column4]}</ErrorTextBox>
      </Box>

      <Box mt={"20px"} sx={{ pb: { sm: "10px", xs: "0" } }}>
        <Button
          startIcon={buttonSvg}
          sx={buttonStyles ? buttonStyles : { width: "100%" }}
          onClick={handleFormSubmit}
        >
          {buttonName}
        </Button>
      </Box>
      {isViewCancelButton && (
        <Box mt={"5px"}>
          <Typography
            className="cursor-pointer"
            variant="body2"
            sx={{ color: colors.basics.primary }}
            onClick={() => cancelButtonClick()}
          >
            Cancel
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default ProfileEdit;
